import { useLocation } from "react-router";
import { useParams } from "react-router-dom";
import useAsyncEffect from "../../../../hooks/useAsyncEffect";
import usePaginationFilter from "../../../../hooks/usePaginationFilter";
import {
    DesvincularContatosController,
    ListarContatosFiltroController,
} from "../../../../Controllers/Automacao/Contato/ContatoControllers";
import { GetsAudienciaController } from "../../../../Controllers/Automacao/Audiencia/AudienciaControllers";
import useAsyncCallback from "../../../../hooks/useAsyncCallback";
import { useState } from "react";
import { IComponentModal } from "../../../../Components/Modais/IModalComponent";

interface RouteParams {
    idAudiencia: string;
}
export function useGestaoContatosNaAudiencia() {
    const { PageFilter, setPage } = usePaginationFilter({ page: 1 });
    const params = useParams<RouteParams>();
    const location = useLocation();
    const { idAudiencia } = params;

    const [show, setShow] = useState(false);
    const [modal, setModal] = useState<IComponentModal>();

    const {
        value: lstContatos,
        loading: lstContatosLoading,
        execute: lstContatosExec,
    } = useAsyncEffect(async () => {
        return ListarContatosFiltroController({
            QUANTIDADE: 10,
            PAGINA: PageFilter.page,
            FL_VINCULADO: true,
            ID_AUDIENCIA: Number(idAudiencia),
            ID_CONTA: 0,
            DS_NOME_CONTATO: "",
            ID_EMPREENDIMENTOS: [],
            ID_TIPO_CONTA: 0,
            ID_PERFIL_FINANCEIRO_CONTA: 0,
            ID_ETAPA_JORNADA: 0,
            NR_UNIDADES_INICIAL: 0,
            NR_UNIDADES_FINAL: 0,
            VL_VGV_TOTAL_INICIAL: 0,
            VL_VGV_TOTAL_FINAL: 0,
        });
    }, [PageFilter]);

    const { value: getAudiencia } = useAsyncEffect(async () => {
        return GetsAudienciaController().then((res) => {
            return res.find(
                (audiencia) => audiencia.ID_AUDIENCIA === Number(idAudiencia)
            );
        });
    }, []);

    const { execute: desvincularContato } = useAsyncCallback(
        async (idContato) => {
            return DesvincularContatosController(Number(idAudiencia), [
                idContato,
            ]).then((res) => {
                lstContatosExec();
            });
        },
        []
    );
    const totalPaginas = lstContatos ? lstContatos[0]?.NR_PAGINAS || 1 : 1;
    return {
        totalPaginas,
        desvincularContato,
        getAudiencia,
        lstContatos,
        lstContatosLoading,
        lstContatosExec,
        location,
        idAudiencia,
        setPage,
        show,
        setShow,
        modal,
        setModal,
    };
}
